<template>
    <div>
        <home-detail :scene="scene">
            <template #main>
                <h1>EXCLUSSIVE MUSIC FOR&nbsp;YOUR&nbsp;AD</h1>
                <p>
                    High quality promotional music quickly to download without log-in needed. A flexible variety of
                    genres arranged in folders with English key word searching.
                </p>
                <p>
                    Music files with a structure which is in compliance with the standards of the current 30-second
                    spot, easy to cut for different lengths. Choose from more than 12000 ad music, increasing number of
                    new music database each month.
                </p>
                <br />
                <h2>LICENSE</h2>
                <p>
                    Music license for only 50 EUR + VAT, 1 year / 1 territory license. Slovak and Czech authors with
                    their tracks exclusively composed only for our database. Exclusivity guarantee only for your work.
                </p>
            </template>
            <!--  <template #right>
                <div block="buttons">
                    <nav-button :to="'/music-zone/demo1'" :text="'MUSIC ZONE DEMO'" :icon="'videocam'" size="big" radius="circle" />
                    <nav-button :to="'/music-zone/demo2'" :text="'MUSIC ZONE TUTORIAL'" :icon="'videocam'" size="big" radius="circle" />
                </div>
                <nav-button v-if="scene == 'subpage'" :to="'/music-zone'" class="close" :icon="'close'" color="ghost" size="icon" />
            </template> -->
        </home-detail>
        <div block="subpage">
            <transition name="bottom">
                <router-view view="subpage"></router-view>
            </transition>
        </div>
    </div>
</template>
<script>
import HomeDetail from '@/components/Home/HomeDetail.vue';
import NavButton from '@/components/.global/NavButton.vue';
import Btn from '@/components/.global/Btn.vue';
import Mp3Player from '@/components/.global/Mp3Player.vue';
export default {
    name: 'MusicDatabase',

    props: {
        scene: {
            type: String,
            required: false,
        },
    },

    components: {
        HomeDetail,
        NavButton,
        Mp3Player,
        Btn,
    },
};
</script>
<style lang="less" scoped>
@import '~@variables';
</style>
